// test834
(834 && 0);
